import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {AmplitudeOfferPromotionLocation} from "../../promotion/tracking/get_amplitude_offer_promotion_event_properties";

export type AmplitudeOfferPageButtonName = "offer_show_number" | "offer_call_investor";

export interface ITrackAmplitudeOfferButtonClickParams {
    buttonName: AmplitudeOfferPageButtonName;
    buttonCategory: AmplitudeOfferPromotionLocation;
    itemId: number;
}

export const trackAmplitudeOfferButtonClick = (params: ITrackAmplitudeOfferButtonClickParams) => {
    trackAmplitudeEvent("button_click", {
        button_name: params.buttonName,
        button_category: params.buttonCategory,
        item_id: params.itemId
    });
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {AmplitudeOfferPromotionLocation} from "../../promotion/tracking/get_amplitude_offer_promotion_event_properties";

export type AmplitudeOfferPageButtonName = "offer_show_number" | "offer_call_investor";

export interface ITrackAmplitudeOfferButtonClickParams {
    buttonName: AmplitudeOfferPageButtonName;
    buttonCategory: AmplitudeOfferPromotionLocation;
    itemId: number;
}

export const trackAmplitudeOfferButtonClick = (params: ITrackAmplitudeOfferButtonClickParams) => {
    trackAmplitudeEvent("button_click", {
        button_name: params.buttonName,
        button_category: params.buttonCategory,
        item_id: params.itemId
    });
};
